module.exports = __webpack_public_path__ + "img/Campari.9b574969.png";